import { animate } from "popmotion"

const faqBlocks = document.querySelectorAll(".faq-block")

faqBlocks.forEach((block) => {
    const items = block.querySelectorAll(".faq-item")

    items.forEach((item) => {
        const triggers = item.querySelectorAll(".open-trigger")

        triggers.forEach((trigger) => {
            trigger.addEventListener("click", () => {
                const isOpen = item.classList.contains("is-open")

                items.forEach((otherItem) => {
                    if (otherItem !== item || isOpen) {
                        closeFaqItem(otherItem)
                    }
                })

                if (!isOpen) {
                    openFaqItem(item)
                }
            })
        })
    })

    const openItem = block.querySelector(".faq-item.is-open")
    if (openItem) {
        setOpenHeight(openItem)
    }
})

function setOpenHeight(item) {
    const target = item.querySelector(".open-target")
    if (!target) {
        return
    }

    target.style.height = "auto"
    target.style.height = target.scrollHeight + "px"
}

function openFaqItem(item) {
    const target = item.querySelector(".open-target")
    const whenClosedEl = item.querySelector(".when-closed")
    const whenOpenedEl = item.querySelector(".when-opened")

    if (!target) {
        return
    }

    const fromHeight = parseFloat(target.style.height.replace("px", "")) || 0

    animate({
        from: fromHeight,
        to: target.scrollHeight,
        onUpdate: (value) => {
            target.style.height = value + "px"
        },
    })

    item.classList.add("is-open")

    if (whenOpenedEl) {
        whenOpenedEl.style.display = "block"
    }
    if (whenClosedEl) {
        whenClosedEl.style.display = "none"
    }
}

function closeFaqItem(item) {
    const target = item.querySelector(".open-target")
    const whenClosedEl = item.querySelector(".when-closed")
    const whenOpenedEl = item.querySelector(".when-opened")

    if (!target || !item.classList.contains("is-open")) {
        return
    }

    const fromHeight = target.scrollHeight

    animate({
        from: fromHeight,
        to: 0,
        onUpdate: (value) => {
            target.style.height = value + "px"
        },
    })

    item.classList.remove("is-open")

    if (whenOpenedEl) {
        whenOpenedEl.style.display = "none"
    }
    if (whenClosedEl) {
        whenClosedEl.style.display = "block"
    }
}
